import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

export default function FeaturedSection() {
  const featured = movies.filter((m) => m.isHot).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-1 h-5 rounded-full bg-accent-500" />
              <h2 className="text-white text-lg font-semibold">精选推荐</h2>
            </div>
            <Link
              to="/category"
              className="text-foreground-500 hover:text-primary-400 text-sm transition-colors flex items-center gap-1"
            >
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {featured.map((movie) => (
              <div key={movie.id} className="flex justify-center">
                <MovieCard movie={movie} size="md" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}